import React, { useEffect, useState } from "react";
import axios from "axios";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./galleryRectangle.css";

const GalleryRectangle = () => {
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios
      .get("https://admin.cmpranesh-admk.com/api/getgallerysection.php")
      .then((res) => {
        const formattedSlides = res.data.map((item) => ({
          src: `https://admin.cmpranesh-admk.com/${item.image}`,
        }));
        setSlides(formattedSlides);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <div className="gallery-rectangle-wrapper">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`gallery-rectangle-item gallery-rectangle-${i}`}
            onClick={() => {
              setIndex(i);
              setOpen(true);
            }}
          >
            <img src={slide.src} alt={`Gallery ${i}`} />
          </div>
        ))}
      </div>

      {slides.length > 0 && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={index}
        />
      )}
    </>
  );
};

export default GalleryRectangle;
